import React from 'react';

export class Dropdown extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.state.data = this.props.Data;


        this.handleChange = this.handleChange.bind(this);

    }
    handleChange(e) {

        console.log(e);
        if (typeof this.props.onChange === "function")
            this.props.onChange(e.target.value, this.props.name);

    }

    componentDidMount() {

        this.state.selected = this.props.Selected;

    }

    render() {


        var divStyleOp = {

            dir: 'rtl',
            'textAlign': 'center'

        };

        //   console.log(this.props.Data);
        if (this.props.Data != null) {
            var options = this.props.Data.map((data) =>
                <option style={divStyleOp} key={data.id} value={data.id}>{data.name}</option>
            );
        }
        else {
            var options = "";
        }

        var emptyOption = null;
        if (this.props.showEmptyOption === false) {

        }
        else {
            var emptyOption = <option style={divStyleOp} key={-1} value={-1}>انتخاب کنید</option>;
        }

        console.log();

        return (

            <div class="input-group" style={{ width: "100%" }}>
                <div class="input-group-prepend" style={{ width: "30%" }}>
                    <span class="input-group-text" style={{ width: "100%" }}>{this.props.label}</span>
                </div>
                    <select 

                        className="custom-select"
                        value={this.props.Selected}
                        
                        ref="myRef"
                        required={this.props.required}
                        onChange={this.handleChange}>
                        {emptyOption}
                        {options}
                    </select>
                
            </div>

        );
    }
}



// WEBPACK FOOTER //
// ./src/elements/Dropdown.js